import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";

export interface Label {
  id: string;
  name: string;
}

export const useLabels = () => {
  const [labels, setLabels] = React.useState<Label[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => { await getLabels() })();
  }, []);

  const getLabels = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Labels}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setLabels(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  return { labels, fetching };
};
